import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { WarningAmber } from '@mui/icons-material';
import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import theme from '../../../../theme/theme';

interface WarningBannerProps {
  title: string;
  message: string;
}

export const WarningBanner: React.FC<WarningBannerProps> = ({
  title,
  message,
}) => {
  const { tokens } = useTheme<LensTheme>();

  return (
    <Box
      sx={{
        backgroundColor: theme.newPalette.yellow.Y600,
        borderRadius: tokens.semantic.radius.md.value,
        padding: tokens.core.spacing[1].value,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: tokens.core.spacing[2].value,
      }}
    >
      <WarningAmber
        sx={{ color: theme.newPalette.yellow.Y500, flexShrink: 0 }}
      />
      <Box>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 600,
            color: theme.newPalette.yellow.Y500,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            color: theme.newPalette.yellow.Y500,
            whiteSpace: 'pre-line',
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};
